import styled from 'styled-components';
import { motion } from 'framer-motion';

import ProfileTile from '../Tile/ProfileTile/ProfileTile';
import SocialMediaTile from '../Tile/SocialMediaTile/SocialMediaTile';
import HistoryTile from '../Tile/HistoryTile/HistoryTile';
import ExperienceTile from '../Tile/ExperienceTile/ExperienceTile';
import SkillsTile from '../Tile/SkillsTile/SkillsTile';
import HariTile from '../Tile/HariTile/HariTile';
import EducationTile from '../Tile/EducationTile/EducationTile';
import ContactTile from '../Tile/ContactTile/ContactTile';
import AITile from '../Tile/AITile/AITile';

const TileIndex = ({ tiles }) => {
  return (
    <Wrapper>
      {tiles.map((tile) => (
        <TileBox
          as={motion.div}
          layoutId={tile.id}
          key={tile.id}
          type={tile.type}
        >
          {tile.content === 'Project - 2' && <EducationTile />}
          {tile.content === 'Project - 1' && <SkillsTile />}
          {tile.content === 'Project - 3' && <ExperienceTile />}
          {tile.content === 'About - Profile' && <ProfileTile />}
          {tile.content === 'About - LinkedIn' && (
            <SocialMediaTile value='linkedIn' />
          )}
          {tile.content === 'Personal History' && <HistoryTile />}
          {tile.content === 'About - Maps' && (
            <SocialMediaTile value='github' />
          )}
          {tile.content === 'Square - Spotify' && <HariTile />}
          {tile.content === 'Contacts' && <ContactTile />}
          {tile.content === 'Night Mode' && <AITile />}
        </TileBox>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(280px, 100%), 1fr));
  grid-template-rows: repeat(4, minmax(min(280px, 100%), 1fr));
  gap: 16px;
  margin: -16px auto 0px;
  max-width: 1200px;
  height: 100%;
  padding: 0 16px;

  @media (max-width: 500px) {
    grid-template-columns: repeat(2, minmax(min(164px, 100%), 1fr));
    grid-template-rows: repeat(auto-fill, minmax(min(164px, 100%), 1fr));
    gap: 8px;
    margin: 0 8px;
  }
`;

const TileBox = styled.div`
  min-height: 280px;
  background-color: ${({ theme }) => theme.tileBackground};
  border-radius: 32px;
  text-align: center;
  grid-column-end: ${(props) => (props.type === 'rh' ? 'span 2' : null)};
  grid-row-end: ${(props) => (props.type === 'rv' ? 'span 2' : null)};
  overflow: hidden;
  filter: drop-shadow(0.05rem 0.1rem 0.1rem rgba(0, 0, 0, 0.2));
  border: ${({ theme }) => theme.border};

  @media (max-width: 500px) {
    min-height: 164px;
    height: ${(props) => (props.type === 'rv' ? '328px' : '100%')};
    grid-column-end: ${(props) => (props.type === 'rh' ? 'span 2' : null)};
  }
`;

export default TileIndex;
